import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';

export default {
	name: 'auto-handover',
	components: {
		BasicSelect,
		VueElementLoading,
		Paginate
	},
	data: function() {
		return {
			isLoadingSearch: false,
			isLoadingbaginscan:false,
			areaBarcode:"",
		  entityName:"",
			autoHandoverBatchData :{},
			BatchDetails:{},
			hubDetailsData :{},
			bagNo:"",
			mpsid:"",
			batchid:"",
			handOverAreaErrorMSG:"",
			ConfirmationModal : false,
			ConfirmationModal1 : false,
			bagNoErrorMSG:"",
			showConfirm: false,
			showConfirm1: false,
			isBarcodeScan: false,
			showMultipartBagPendingModal :false,
			multipartBagDetails : [],
			showBag:false,
			LoginHubId:'',
			IsPaperWorkBag:false,
			isInscanSuccess:true,
			paperbagno:'',
			PaperBagNoError:'',
			paperstatus:'',
			generatedPaperBagNoDetails:'',
			IsAllow:false,
			parentawbno:'',
			parentawbnoError:'',
			Isparentawbno:false,
			finalpaperbagno: '',
      FinalPaperBagNoError: '',
			isExistBag: false,
			datanumbrt:"1",
			connectionId:'',
			connectionname:'',
			timeoutHandler: 0,
			inputString:'',
			manualInput : false,
			isLoadingpaperbag:false,
			disablescanInBtn:true,
			disablestartscan:true,
			searchMPSId:'',
			searchMPSIdErrorMSG:'',
			totalCount:0,
			pageCount:0,
			pageNo: 0,
			limit:10,
			isLoadingBatch:false,
			showpaperBagno:false,
			totalOutscanMPS:0,
			disableconfirm:true,
			autohandoverbatchid:'',
			useremail:'',
			pagedata:[],
			hubzonelist: [],
      hubzoneitem: {
				id: '',
				text: ''
			},
      hubzone: '',
      hubzoneLoading: '',
			zoneErrorMSG:'',
			iszonerequired:false,
			isdisabledzone:false,
			isLoadingResult: false,
			showPendingModal: false,
			form: {
				group: []
			},
			AWBBarcode: "",
			totalPendingCount: 0,
			removepaperbagno: '',
			paperawbno: '',
			AWBBarcodeErrorMsg: '',
			isRemoveEvent: false,
			isConfirm: false,
			isScanner: false,
			multipartMPSDetails: [],
			physicalWeight:0,
			volumetricWeight:0,
			physicalWeightmps:0,
			volumetricWeightmps:0,
			batchcount:0,
			istcpl:false
		}
	},
	created: function() {},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.useremail = userdetail[0].email;
		this.LoginHubId =userdetail[0].HubId[0];
		this.$refs.areaBarcode.focus();
	},
	methods: {
		checkBarcode(e){
			if (this.timeoutHandler) {
				clearTimeout(this.timeoutHandler)
				this.inputString += String.fromCharCode(e.keyCode)
			}
			this.timeoutHandler = setTimeout(() => {
				if (this.inputString.length <= 3) {
					this.manualInput = true
				  this.inputString = ''
				}else{
					this.manualInput = false
				  this.inputString = ''
				}
			}, 10)
		},

		getBarcodeScan() {
			this.resetareaBarcode();
			if (!this.areaBarcode) {
				this.handOverAreaErrorMSG = 'Enter HandOver Area Barcode';
				return false;
			}
			this.isLoadingSearch=true;
			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'showAHEntityDetails?Barcodedata=' + this.areaBarcode.toString()+ "&LoginHubId=" + this.LoginHubId,
				headers: {
					'Authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoadingSearch=false;
					if (result.data.ResultCode == 100) {
						this.disablestartscan=false;
						this.hubDetailsData = result.data.ResponseData;
						this.entityName = this.hubDetailsData[0].tohubname;
						this.connectionId = this.hubDetailsData[0].connectionid;
						this.connectionname = this.hubDetailsData[0].connectionname;
						this.iszonerequired= this.hubDetailsData[0].iszonerequired;
					  this.getHubZone();
					} else {
						this.hubDetailsData  = {};
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					console.error(error)
					this.isLoadingSearch=false;

				})
			},

			getHubZone() {
	      this.hubzoneLoading = 'Loading Hub Zone...'
	      var i = 0;
	      var userToken = window.localStorage.getItem('userToken')
	      var myStr = userToken.replace(/"/g, '');
	      this.input = ({})
	      axios({
	          method: 'POST',
	          'url': apiUrl.api_url_hubops + 'hubzone/list',
	          'data': this.input,
	          headers: {
	            'authorization': 'authkey xB84JJ89Hd25',
	          }
	        })
	        .then(result => {
	          this.hubzoneLoading = ''
	          this.HubZoneListData = result.data.ResponseData;
	          for (i = 0; i < this.HubZoneListData.length; i++) {
	            this.hubzonelist.push({
	              id: this.HubZoneListData[i].hubzoneid,
	              text: this.HubZoneListData[i].hubzonename
	            })
	          }
	        }, error => {
	          console.error(error)
	        })
	    },

	    selectHubZone(hubzoneitem) {
	      this.hubzoneitem = hubzoneitem
	      this.hubzone = this.hubzoneitem.text
	      this.hubzoneid = this.hubzoneitem.id
	    },

		startScan() {
			if (!this.areaBarcode) {
				this.handOverAreaErrorMSG = 'Enter HandOver Area Barcode';
				return false;
			}else if (this.iszonerequired === true && this.hubzoneitem.text=='') {
				this.zoneErrorMSG = 'Enter Hub Zone';
					return false;
			}
			this.resetPaperBag();
			this.pageNo=0;
			this.totalCount=0;
			this.batchcount=0;
			this.autoHandoverBatchData = [];
			this.isBarcodeScan = false;
			this.batchid ='';
			this.zoneErrorMSG='';
			this.physicalWeight=0;
			this.volumetricWeight=0;
			this.physicalWeightmps=0;
			this.volumetricWeightmps=0;
			this.input = ({
				FromHubId: this.hubDetailsData[0].fromhubid,
				ToHubId: this.hubDetailsData[0].tohubid,
				Barcodedata: this.areaBarcode.toString(),
				CreatedBy: this.useremail,
				limit:this.limit,
				offset:this.pageNo,
				zone:this.hubzoneitem.text,
			})
			this.isLoadingSearch=true;
			axios({
				method: "POST",
				'url': apiUrl.api_url_hubops + 'CreateAHBatch',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			}).then(result => {
				this.isLoadingSearch=false;
				let response = result.data;
				if (response.ResultCode == 100 ) {
					this.disablescanInBtn = false;
					this.isdisabledzone= false;
					this.isBarcodeScan = true;
					let BatchDetails = response.ResponseData;
					this.batchid = BatchDetails.batchid;
					this.isecom = BatchDetails.isecom
					this.istcpl = BatchDetails.istcpl
					if(BatchDetails.noofbags != 0 ){
						let Bags = BatchDetails.BagData;
						for(let i= 0 ; i < Bags.length; i++){
							this.autoHandoverBatchData.push({
								bagNo: Bags[i].bagno,
								bagDestination:Bags[i].bagDestination,
								bagtype:Bags[i].bagtype,
								groupno:Bags[i].groupno
							})
						}
						this.disablescanInBtn = true;
						this.isdisabledzone= true;
						this.physicalWeight=BatchDetails.TotalPhysicalWeight;
						this.volumetricWeight=BatchDetails.TotalVolumetricWeight;
					}
						if(BatchDetails.noofmps){
	 						let MPSData = BatchDetails.MPSData;
	 						for(let i= 0 ; i < MPSData.length; i++){
								this.autoHandoverBatchData.push({
									mpsid: MPSData[i].MPSNo,
	 								MPSDestination: MPSData[i].MPSDestination
	 							})
	 						   }
								this.physicalWeightmps=BatchDetails.TotalPhysicalWeight;
								this.volumetricWeightmps=BatchDetails.TotalVolumetricWeight;
							}
								if(this.isecom === false){
                                    this.getPaperBagData();
								}else if(BatchDetails.istcpl){
								  this.disablescanInBtn = true;
								}
								 this.totalCount = (this.isecom==false || BatchDetails.istcpl) ? BatchDetails.noofmps:BatchDetails.noofbags;
								 this.batchcount = this.totalCount;
								 if (this.totalCount < 10) {
		               this.pageCount = 1
		             } else {
		               this.pageCount = Math.ceil(this.totalCount / 10);
		             }
								 if(this.pageNo==0){
									 this.pagedata=this.autoHandoverBatchData;
								 }
							 }else{
								 this.$alertify.error(response.ReturnMessage);
							 }
						 }, error => {
							 console.error(error);
							 this.isLoadingSearch=false;
				})
			},

		bagInscan(){
				this.multipartBagDetails = [];
				if (!this.bagNo) {
					this.bagNoErrorMSG = 'Bag/Mps no is required';
					return false;
				}

				let api;
       if(this.isecom == false){
         api = 'AddMpsToBatchB2B';
				 this.input = ({
 					Batchid: this.batchid,
 					HubId: this.hubDetailsData[0].fromhubid,
 					HubName:this.hubDetailsData[0].fromhubname,
          MPSNo: this.bagNo,
					connectionId:this.connectionId,
 					createdBy: this.useremail,
					selectedzone:this.hubzoneitem.text
 				})
       }
			 else {
			 	 api = 'AddtoBatchB2C';
				 this.input = ({
 					batchid: this.batchid,
 					currentHubId: this.hubDetailsData[0].fromhubid,
 					currentHubName:this.hubDetailsData[0].fromhubname,
          bagNo: this.bagNo,
 					createdBy: this.useremail,
					connectionId:this.connectionId,
					selectedzone:this.hubzoneitem.text

 				})
				this.disablescanInBtn = true;
				this.isdisabledzone= true;
			 }
				this.bagNoErrorMSG = '';
				this.isLoadingbaginscan= true
				axios({
					method: "POST",
					'url': apiUrl.api_url_hubops + api,
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				}).then(result => {
					this.isLoadingbaginscan= false;
					let response = result.data;
					if (response.ResultCode == 100 ) {
						this.showpaperBagno = true
					    this.$alertify.success(response.ReturnMessage)
							this.bagNo='';
							if (this.totalCount!= response.ResponseData[0].BagCount) {
								 this.totalCount= response.ResponseData[0].BagCount;
							}
							this.autoHandoverBatchData=this.pagedata?this.pagedata:[];
							this.batchcount = (this.isecom==false || response.ResponseData[0].istcpl) ? response.ResponseData[0].noofmps:this.totalCount;
							this.$refs.paginate.selected = 0;
					}
					else if(response.ResultCode == 110){
						this.showBag = false;
					  this.multipartBagDetails = response.ResponseData;
						this.showMultipartBagPendingModal = true;
						this.$alertify.error(response.ReturnMessage);
					}else{
						this.$alertify.error(response.ReturnMessage);
					}
				}, error => {
					console.error(error);
					this.isLoadingbaginscan= false;
				})


			},

		removeBag(data){

			if(this.isecom == false || this.istcpl){
				this.input = ({
					MPSNo:data.mpsid,
					Batchid: this.batchid,
					HubId: this.hubDetailsData[0].fromhubid,
					HubName: this.hubDetailsData[0].fromhubname,
					ModifiedBy: this.useremail
				  })
				}
				else {
					this.input = ({
						MPSNo:data.bagNo,
						Batchid: this.batchid,
						HubId: this.hubDetailsData[0].fromhubid,
						HubName: this.hubDetailsData[0].fromhubname,
						ModifiedBy: this.useremail
					  })
				}
				axios({
					  method: 'PUT',
					  'url': apiUrl.api_url_hubops + 'ahRemovebag',
					  'data': this.input,
					  headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					  }
					})
					.then(result => {

					  if (result.data.ResultCode == 100) {
						this.$alertify.success('Remove Successfully', "", "success")
						this.FetchAHBatch();
					  }else{
						this.$alertify.error(result.data.ReturnMessage);
					  }
					}, error => {
					  console.error(error)

					})

			},

		confirmBagHandover(){
			this.multipartBagDetails = [];
					this.input = ({
						batchid: this.batchid,
						currentHubId: this.hubDetailsData[0].fromhubid,
						currentHubName: this.hubDetailsData[0].fromhubname,
						lastmodifiedby: this.useremail
					  })
				this.isLoadingResult = true;
			  	axios({
				  method: 'PUT',
				  'url': apiUrl.api_url_hubops + 'ahOutscan',
				  'data': this.input,
				  headers: {
					  'authorization': 'authkey xB84JJ89Hd25',
				  }
			  	}).then(result => {

				  let response = result.data;
				  if (response.ResultCode == 100) {
					  this.$alert(result.data.ReturnMessage, "", "success");
					  this.resetForm();
				  }else if(response.ResultCode == 110){
					  this.isLoadingResult = false;
					  this.showBag = true;
					  this.multipartBagDetails = response.ResponseData;
					  this.totalPendingCount = 0;
					  this.multipartBagDetails.map(baginfo => {
						  this.totalPendingCount += baginfo.BagData.length;
					  });
					  this.showPendingModal = true;
					  this.$alertify.error(response.ReturnMessage);
				  }
				  else{
					  this.$alertify.error(response.ReturnMessage);
					  this.isLoadingResult = false;
				  }
				  this.ConfirmationModal = false;
					this.ConfirmationModal1 = false;
			  }, error => {
				  console.error(error);
				  this.isLoadingResult = false;
			  	})
		    },

		openConfirmationModal(data) {
				this.showConfirm = data;
			   this.ConfirmationModal = true;
			},

		openConfirmationModal1(data1) {
			this.showConfirm1 = data1;
			this.ConfirmationModal1 = true;
		},

		closeConfirmationModal() {
			  this.ConfirmationModal= false;
				this.showConfirm = false;
		    },

		closeConfirmationModal1() {
			this.ConfirmationModal1= false;
			this.showConfirm1 = false;
			 },

		resetForm() {
			  this.entityName = "";
				this.areaBarcode = "";
				this.autoHandoverBatchData = [];
				this.pagedata=[];
				this.batchid ='';
				this.bagNo="";
				this.handOverAreaErrorMSG ="";
				this.bagNoErrorMSG = "";
				this.isBarcodeScan = false;
				this.$validator.reset();
				this.errors.clear();
				this.multipartBagDetails = [];
				this.isLoadingpaperbag=false;
				this.isLoadingbaginscan=false;
				this.disablescanInBtn= true;
				this.isdisabledzone= false;
				this.disablestartscan=true;
				this.searchMPSId='';
				this.searchMPSIdErrorMSG='';
				this.totalCount=0;
				this.pageNo= 0;
				this.isLoadingBatch=false;
				this.showpaperBagno = false;
				this.totalOutscanMPS=0;
				this.disableconfirm=true;
				this.autohandoverbatchid='';
				this.hubzonelist= [];
	      this.hubzoneitem= {
					id: '',
					text: ''
				};
				this.zoneErrorMSG='';
	      this.hubzone= '';
	      this.hubzoneLoading= '';
				this.iszonerequired=false;
				this.physicalWeight=0;
				this.physicalWeightmps=0;
				this.volumetricWeight=0;
				this.volumetricWeightmps=0;
				this.batchcount =0;
				this.resetPaperBag()
		    },

		resetareaBarcode(){
					this.entityName = "";
					this.autoHandoverBatchData = [];
					this.batchid ='';
					this.bagNo="";
					this.handOverAreaErrorMSG ="";
					this.zoneErrorMSG='';
					this.bagNoErrorMSG = "";
					this.isBarcodeScan = false;
					this.$validator.reset();
					this.errors.clear();
					this.multipartBagDetails = [];
					this.connectionId ='';
					this.connectionname='';
					this.showpaperBagno = false;
				},

		reset(){
				this.bagNo="";
				this.bagNoErrorMSG = "";
			},

		closeMutlipartPendingModal(){
				this.showMultipartBagPendingModal  =false;
		    this.multipartBagDetails = [];
			},
		closePendingModal() {
			this.showPendingModal = false;
			this.multipartBagDetails = [];
		},
		closePaperWorkCard() {
	      this.isInscanSuccess = false
	      this.IsPaperWorkBag = false
	      this.resetPaperBagNo()
	    },

		openPaperWorkCard() {
			if (!this.batchid) {
				this.$alertify.error("Batch id is empty")
				return false;
			}
      this.isInscanSuccess=false
      this.IsPaperWorkBag = true
			this.isRemove = false;
			this.isConfirm = false;
			this.isScanner = false;
      window.scrollTo(0, 1000);
      this.getPaperBagData();
    },

		getPaperBagData() {
			this.isLoadingpaperbag=true;
			this.input = ({
        "batchId": this.batchid,
        "currentHubId": this.hubDetailsData[0].fromhubid,
        "createdBy": this.useremail,
      })
				axios({
					method: 'GET',
          url: apiUrl.api_url_hubops + 'getPaperBagsByBatchId?batchId=' + this.batchid + "&currentHubId=" + this.hubDetailsData[0].fromhubid + "&createdBy=" + this.useremail,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
					this.isLoadingpaperbag=false;
            if (result.data.ResultCode == 100) {
              this.isExistBag = true
							this.isecom = false
              this.paperstatus = result.data.ResponseData.paperstatus
              this.listpaperbagno = result.data.ResponseData.paperbagno
              this.paperbagno = this.listpaperbagno
							this.autohandoverbatchid=result.data.ResponseData.autohandoverbatchid
              this.Isparentawbno = true
            } else {
              this.isExistBag = false
              this.Isparentawbno = false
              this.paperstatus = ''
              this.listpaperbagno = ''
              this.paperbagno = ''
            }
          },
          error => {
            console.error(error)
						this.isLoadingpaperbag=false;
          })
    },

		resetPaperBagNo(){
			this.isLoadingpaperbag=false;
			this.paperbagno=''
			this.PaperBagNoError=''
      this.isInscanSuccess = false
      this.paperstatus = ''
      this.listpaperbagno = ''
      this.paperbagno = ''
      this.PaperBagNoError = ''
      this.parentawbno = ''
      this.parentawbnoError = ''
      this.Isparentawbno = false
      this.isExistBag = false
      this.IsAllow = false
      this.generatedPaperBagNoDetails = []
		},

		getGeneratedPaperBagNoDetails(isRemove) {
			this.generatedPaperBagNoDetails = []
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getAHPaperWorkDetailsByPaperBagNo?paperBagNo=' + this.paperbagno.trim() ,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then(result => {
						if (result.data.ResultCode == 100) {
							this.generatedPaperBagNoDetails = result.data.ResponseData
							if (isRemove != 1) {
								this.$alertify.success(result.data.ReturnMessage)
							}
						} else {
							if (isRemove != 1) {
								this.$alertify.error(result.data.ReturnMessage)
							}
						}
					},
					error => {
						console.error(error)
					})
		},
		closeScanParentAWBModal() {
			this.isScanner = false;
			this.isConfirm = false;
			this.isRemoveEvent = false;
			this.AWBBarcodeErrorMsg = '';
			this.AWBBarcode = '';
		},
		closeConfirmScanParentAWB() {
			this.isConfirm = false;
			this.isScanner = false;
			this.isRemoveEvent = false;
		},
		confirmRemove(data, index) {
			this.removepaperbagno = data.paperbagno;
			this.paperawbno = data.parentawb;
			this.isScanner = false;
			this.isRemoveEvent = true;
			this.isConfirm = true;
		},
		RemoveRow() {
			this.isConfirm = false;
			this.isRemoveEvent = true;
			this.isScanner = true;
			this.AWBBarcodeErrorMsg = '';
			this.AWBBarcode = '';
			this.$nextTick(() => {
				this.$refs.AWBBarcode.focus();
			})
		},
		getAWBBarcodeScan() {
			if (!this.AWBBarcode || this.AWBBarcode == '') {
				this.AWBBarcodeErrorMsg = 'Please Scan Parent AWB Barcode';
				return false;
			}
			if (this.AWBBarcode.toLowerCase() !== this.paperawbno.toLowerCase().trim()) {
				this.AWBBarcodeErrorMsg = 'Parent AWB No is not Valid';
				return false;
			}
			this.AWBBarcodeErrorMsg = '';
			this.AWBBarcode = '';
			this.isRemoveEvent = false;
			this.isConfirm = false;
			this.isScanner = false;
			this.RemoveParentAWBNo();
		},
		RemoveParentAWBNo() {
			this.input = ({
				"parentMPS": this.paperawbno,
				"paperBagNo": this.removepaperbagno,
				"modifiedBy": this.useremail
			})
			axios({
					method: 'PUT',
					url: apiUrl.api_url_hubops + 'removeParentAWB',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then(result => {

						if (result.data.ResultCode == 100) {
							this.$alertify.success(result.data.ReturnMessage)
							this.getGeneratedPaperBagNoDetails(1)
							this.pageNo= 0;
						} else {
							this.$alertify.error(result.data.ReturnMessage)
						}
					},
					error => {
						console.error(error)

					})
		},

		generatePaperBagNo() {
			if (this.paperbagno == '') {
				this.PaperBagNoError = 'The Bag No field is required.'
				return false;
			} else {
				this.PaperBagNoError = ''
				this.isLoadingpaperbag= true;
				this.input = ({
					"paperBagNo": this.paperbagno.trim(),
					"batchid":this.batchid,
					"isActive": true,
					"currentHubId":  this.hubDetailsData[0].fromhubid,
					"currentHubName":  this.hubDetailsData[0].fromhubname,
					"createdBy":this.useremail
				})
				axios({
						method: 'POST',
						url: apiUrl.api_url_hubops + 'generatePaperLessWorkBag',
						data: this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
							'requestfrom': "WEB",
							'token': this.token
						}
					})
					.then(result => {
						this.isLoadingpaperbag=false;
							if (result.data.ResultCode == 100) {
								this.isecom = false
								this.$alertify.success(result.data.ReturnMessage)
								 this.getPaperBagData();
							}else if (result.data.ResultCode == 105) {
								this.isecom = false
								this.isExistBag = true
								this.getPaperBagData();
								this.$alertify.success(result.data.ReturnMessage)
							} else {
								this.Isparentawbno = false
								this.$alertify.error(result.data.ReturnMessage)
							}
						},
						error => {
							console.error(error)
							this.isLoadingpaperbag=false;
						})
			}
		},

		clearFinalPaperBagNoError() {
      if (this.finalpaperbagno == '') {
        this.FinalPaperBagNoError = "The Paper Bag No field is required."
      } else {
        this.FinalPaperBagNoError = ''
      }
    },

		scanOutPaperBag() {
			if (this.finalpaperbagno == '') {
				this.FinalPaperBagNoError = "The Paper Bag No field is required."
				return false;
			} else {
				this.FinalPaperBagNoError = ''
				this.input = ({
					"PaperBagNo": this.finalpaperbagno,
					"currentHubId": this.LoginHubId,
					"currentHubName": this.hubDetailsData[0].fromhubname,
					"LastModifiedBy": this.useremail,
					"autohandoverbatchid":this.autohandoverbatchid
				})
				this.isLoadingResult = true;
				axios({
						method: 'PUT',
						url: apiUrl.api_url_hubops + 'ahPaperbagOutscan',
						data: this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25'
						}
					})
					.then(result => {
						if (result.data.ResultCode == 100) {
							this.$alertify.success(result.data.ReturnMessage)
							this.totalOutscanMPS = result.data.noofmps;
							this.batchcount=this.totalOutscanMPS;
							this.physicalWeightmps=(result.data.TotalPhysicalWeight)?result.data.TotalPhysicalWeight:this.physicalWeightmps;
							this.volumetricWeightmps=(result.data.TotalVolumetricWeight)?result.data.TotalVolumetricWeight:this.physicalWeightmps;
							this.finalpaperbagno = ''
							this.FinalPaperBagNoError = ''
							this.disableconfirm= false
						} else if (result.data.ResultCode == 110) {
							this.isLoadingResult = false;
							this.showBag = false;
							this.$alertify.error(result.data.ReturnMessage);
							this.multipartMPSDetails = result.data.ResponseData;
							this.totalPendingCount = 0;
							this.multipartMPSDetails.map(mpsinfo => {
								this.totalPendingCount += mpsinfo.MPSData.length;
							});
							this.showPendingModal = true;
						} else {
							this.$alertify.error(result.data.ReturnMessage)
							this.isLoadingResult = false;
						}
					}, error => {
						console.error(error)
						this.isLoadingResult = false;
					})
			}
		},

		resetPaperBag() {
      this.finalpaperbagno = ''
      this.FinalPaperBagNoError = ''
    },

		inscanparentawbno() {
			this.isInscanSuccess=true
			if (this.parentawbno == '') {
				this.parentawbnoError = 'The Parent AWB field is required.'
				return false;
			} else {
				this.parentawbnoError = ''
				this.input = ({
					"paperBagNo": this.paperbagno.trim(),
					"parentawb": this.parentawbno.trim(),
					"isActive": true,
					"createdBy": this.useremail,
					"currentHubId": this.LoginHubId
				})
				axios({
						method: 'POST',
						url: apiUrl.api_url_hubops + 'ahpaperworkBagin',
						data: this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
							'requestfrom': "WEB",
							'token': this.token
						}
					})
					.then(result => {
							if (result.data.ResultCode == 100) {
								this.isInscanSuccess=false
								this.showpaperBagno = true
								this.$alertify.success(result.data.ReturnMessage)
								this.parentawbno = ''
								this.$validator.reset()
							}  else {
								this.isInscanSuccess=false
								this.$alertify.error(result.data.ReturnMessage)
							}
						},
						error => {
							console.error(error)
						})
			}
		},

		onSubmitPaperBag: function(PaperBagTab) {
			this.$validator.validateAll('PaperBagTab').then((result) => {
				if (!result) {
					console.log('errors exist', this.errors)
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},

		searchOutboundBatch() {
			if (!this.searchMPSId ) {
				this.searchMPSIdErrorMSG = 'Enter MPS Id';
				return false;
			}
			this.totalCount=0;
			this.pageNo=0;
			this.pageCount=0;
			this.$refs.paginate.selected = 0;
			this.autoHandoverBatchData = [];
			this.searchMPSIdErrorMSG='';
			this.isLoading= true;
			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'searchOutboundBatch?searchParam=' + this.searchMPSId+ "&batchid=" + this.batchid+ "&currentHubId=" + this.LoginHubId+ "&isEcom=" + this.isecom,
				headers: {
					'Authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoading= false;
					let response = result.data;
					if (response.ResultCode == 100 ) {
						if (this.isecom== false || this.istcpl) {
							this.autoHandoverBatchData.push({
								mpsid: response.ResponseData[0].mpsid,
								MPSDestination: response.ResponseData[0].finaldestinationhubname
							})
						}
						else {
							this.autoHandoverBatchData.push({
								bagNo: response.ResponseData[0].bagno,
								bagDestination: response.ResponseData[0].finaldestinationhubname,
								bagtype:response.ResponseData[0].bagtype,
								groupno:response.ResponseData[0].groupno
							})
						}
						this.pageNo=0;
					}else{
						this.$alertify.error(response.ReturnMessage);
					}
				}, error => {
					console.error(error)
					this.isLoading= false;
				})
			},

		FetchAHBatch() {
				if (!this.areaBarcode) {
					this.handOverAreaErrorMSG = 'Enter HandOver Area Barcode';
					return false;
				}
				this.searchMPSId=''
				this.searchMPSIdErrorMSG='';
				this.autoHandoverBatchData=[];
				this.physicalWeight=0;
				this.volumetricWeight=0;
				this.physicalWeightmps=0;
				this.volumetricWeightmps=0;
				this.input = ({
					FromHubId: this.hubDetailsData[0].fromhubid,
					ToHubId: this.hubDetailsData[0].tohubid,
					Barcodedata: this.areaBarcode.toString(),
					CreatedBy: this.useremail,
					limit:this.limit,
					offset:this.pageNo
				})
				this.isLoadingBatch= true;
				axios({
					method: "POST",
					'url': apiUrl.api_url_hubops + 'FetchAHBatch',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				}).then(result => {
					this.isLoadingBatch= false;
					let response = result.data;
					if (response.ResultCode == 100 ) {
						let BatchDetails = response.ResponseData;
						this.istcpl = BatchDetails.istcpl
						if(BatchDetails.noofbags != 0 ){
							let Bags = BatchDetails.BagData;
							for(let i= 0 ; i < Bags.length; i++){
								this.autoHandoverBatchData.push({
									bagNo: Bags[i].bagno,
									bagDestination:Bags[i].bagDestination,
									bagtype:Bags[i].bagtype,
									groupno:Bags[i].groupno
								})
							}
							this.physicalWeight=BatchDetails.TotalPhysicalWeight;
							this.volumetricWeight=BatchDetails.TotalVolumetricWeight;
						}
							if(BatchDetails.noofmps){
		 						let MPSData = BatchDetails.MPSData;
		 						for(let i= 0 ; i < MPSData.length; i++){
									this.autoHandoverBatchData.push({
										mpsid: MPSData[i].MPSNo,
		 								MPSDestination: MPSData[i].MPSDestination,
										bagType : BatchDetails.status,
		 							})
		 						   }
									 this.physicalWeightmps=BatchDetails.TotalPhysicalWeight;
									 this.volumetricWeightmps=BatchDetails.TotalVolumetricWeight;
								 }
									 this.totalCount = (this.isecom==false || BatchDetails.istcpl) ? BatchDetails.noofmps:BatchDetails.noofbags;
									 this.batchcount=this.totalCount;
									 if (this.totalCount < 10) {
			               this.pageCount = 1
			             } else {
			               this.pageCount = Math.ceil(this.totalCount / 10);
			             }
									 if(this.pageNo==0){
										 this.pagedata=this.autoHandoverBatchData;
									 }
								 }else{
									 this.$alertify.error(response.ReturnMessage);
								 }
					}, error => {
						console.error(error)
						this.isLoadingBatch= false;
					})
				},

		getPaginationData(pageNum) {
					this.pageNo = 0
		      this.pageNo = (pageNum - 1);
					this.FetchAHBatch();
				},

	}

}



// WEBPACK FOOTER //
// ./src/views/components/AutoHandover_v1/Outbound/Outbound.js